import React from 'react';

interface SkeletonProps {
  width?: string;
  height?: string;
  className?: string;
  variant?: 'text' | 'rect' | 'circle';
}

const Skeleton: React.FC<SkeletonProps> = ({
  width = 'w-full',
  height = 'h-4',
  className = '',
  variant = 'rect',
}) => {
  const variantClasses = {
    text: 'rounded',
    rect: 'rounded-lg',
    circle: 'rounded-full',
  };

  return (
    <div
      className={`
        ${width} ${height}
        ${variantClasses[variant]}
        bg-gradient-to-r from-[#f0f4fb] via-[#e1e9f5] to-[#f0f4fb]
        bg-[length:200%_100%]
        animate-skeleton
        ${className}
      `}
      aria-label="Loading..."
      role="status"
    />
  );
};

export default Skeleton;
